export function stampToDate (stampstr) {
  if (stampstr && stampstr !== '') {
    let date = new Date(stampstr)
    let Y = date.getFullYear() + '-'
    let M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = date.getDate() + ' '
    let h = date.getHours() + ':'
    let m = date.getMinutes() + ':'
    let s = date.getSeconds()
    return Y + M + D + h + m + s
  }
}

export function dateToStamp (datestr) {
  if (datestr && datestr !== '') {
    let date = new Date(datestr.replace(/-/g, '/'))
    return date.getTime()
  }
}

export function getNowTime () {
  let myDate = new Date()
  let timestamp = myDate.getTime()
  return stampToDate(timestamp)
}

export function getNowDate () {
  let nowTime = getNowTime()
  let timeArr = nowTime.split(' ')
  return timeArr[0]
}



// WEBPACK FOOTER //
// ./src/common/date/index.js